import instantsearch from 'instantsearch.js/dist/instantsearch.js';

const validTypes = [
    'Article', 'Case Study', 'Co-Funding', 'Document', 'Event',
    'Expert', 'News', 'Poster', 'Presentation', 'Project',
    'Project Outcomes', 'Report', 'Snapshot Project',
    'Success Story', 'Thesis', 'Workshop', 'Video', 'Kono PLD',
];
const searchData = $('#header__lead--search');
let search;
let resultsPerPage;

export function getSearch(indexName, resultsPerPage, urlTrack, filter) {
    let syncOptions = false;
    if (urlTrack) {
        syncOptions = {
            mapping: { 'q': 'term' },
            trackedParameters: ['query', 'attribute:*'],
        }
    }

    this.resultsPerPage = resultsPerPage;
    search = instantsearch({
        appId: searchData.data('keyApp'),
        apiKey: searchData.data('keySearch'),
        indexName: getIndex(indexName),
        urlSync: syncOptions,
        searchParameters: {
            hitsPerPage: resultsPerPage,
            filters: filter,
        }
    });
    return search;
}

export function widgetInput(userInput, listenerFunction) {
    return {
        init: function (opts) {
            const helper = opts.helper;
            const input = document.querySelector(userInput);
            input.addEventListener('input', function (e) {
                helper.setQuery(e.currentTarget.value).search();
                if (listenerFunction) {
                    listenerFunction();
                }
            });
        }
    }
}

export function widgetHits(container, onResultRefresh) {
    return instantsearch.widgets.hits({
        container: container,
        templates: {
            empty: 'No results match',
            item: function (data) {
                if (onResultRefresh) {
                    onResultRefresh();
                }
                return hitTemplateFull(data)
            }
        },
    })
}

export function widgetDropHits(container) {
    return instantsearch.widgets.hits({
        container: container,
        templates: {
            empty: 'No results match',
            item: function (data) {
                return hitTemplateDrop(data)
            },
        },
    })
}

export function widgetFilterHits(container, onResultRefresh) {
    return instantsearch.widgets.hits({
        container: container,
        templates: {
            empty: 'No results match',
            item: function (data) {
                if (onResultRefresh) {
                    onResultRefresh();
                }
                return hitTemplateFilter(data)
            },
        },
    })
}

export function widgetFilterEventHits(container, onResultRefresh) {
    return instantsearch.widgets.hits({
        container: container,
        templates: {
            empty: 'No results match',
            item: function (data) {
                if (onResultRefresh) {
                    onResultRefresh();
                }
                return hitTemplateEvent(data)
            },
        },
    })
}

export function widgetRefinementList(container, type) {
    return instantsearch.widgets.refinementList({
        container: container,
        attributeName: type,
        limit:10,
        showMore: true,
        showMoreLimit: 40,
        autoHideContainer: false,
        sortBy: ['count:desc', 'name:acs'],
        operator: 'or',
        templates: {
            header: '',
            item: function (data) {
                return filterListTemplate(data, type);
            }
        },
    })
}


export function widgetRegionList(container, type) {

    return instantsearch.widgets.refinementList({
        container: container,
        attributeName: type,
        limit: 40,
        autoHideContainer: false,
        sortBy: ['name:acs'],
        operator: 'or',
        facets: ['Region'],
        templates: {
            header: '',
            item: function (data) {
                return filterListTemplate(data, type);
            }
        },
    })
}

export function widgetNumericRefinementList(container) {
    let thisYear = (new Date()).getFullYear();
    let yearList = [
        { name: 'All' },
        { end: (thisYear - 3), name: 'older' },
        { start: (thisYear - 2), end: (thisYear - 2), name: (thisYear - 2).toString() },
        { start: (thisYear - 1), end: (thisYear - 1), name: (thisYear - 1).toString() },
        { start: thisYear, name: thisYear + '+' },
    ];
    return instantsearch.widgets.numericRefinementList({
        container: container,
        attributeName: 'Year',
        autoHideContainer: false,
        options: yearList,
        templates: {
            header: '',
            item: function (data) {
                return filterNumTemplate(data, 'Year');
            }
        }
    })
}

export function getIndex(index) {
    return searchData.data('algoliaEnv') + index;
}

// fix format of missing datafields
function render(dataField) {
    if (dataField) return dataField;
    else return "";
}

// template for search result (hit) list
function hitTemplateFull(data) {
    search.helper.state.hitsPerPage = resultsPerPage;
    return `
        <div class="knowledge__liststories--story">
            <a
                href="${data.Link}"
                class="knowledge__liststories--story__icon"
                ${data.Class === 'File' ? 'target="_blank"' : ''}
            >
                <img src="${getIcon(data)}">
            </a>
            <!---->
            <div class="knowledge__liststories--story__summary">
                <div class="knowledge__liststories--story__summary--text">
                    ${data.DisplayType === 'General'
            ? ''
            : `<h4>${render(data.DisplayType)}</h4>`
        }
                    <a href="${data.Link}" ${data.Class === 'File' ? 'target="_blank"' : ''}>
                        <h3>${render(data.Title)}</h3>
                    </a>
                </div>
            </div>
            <!---->
            <div class="knowledge__liststories--story__content richtext">
                ${render(data.Summary)}
                <ul>
                    ${renderHitTemplateFile(data.File)}
                    ${renderHitTemplateDate(data)}
                    ${renderHitTemplateList(data.Topic)}
                    ${renderHitTemplateList(data.MaoriResourceTopic)}
                    ${renderHitTemplateList(data.Discipline)}
                </ul>
            </div>
            <!---->
            <div class="knowledge__liststories--story__arrow">
                <a
                    href="${data.Link}"
                    class="arrow arrow__color--pink"
                    ${data.Class === 'File' ? 'target="_blank"' : ''}
                >
                    Read more
                </a>
            </div>
        </div>
    `
};

// template for filtering lists
function filterListTemplate(data, type) {
    let template = ' <div class="form__wrapper"><label for="' +
        (type + '-' + data.value).replace(/\s+/g, '-').toLowerCase()
        + '">' + data.value + '<input type="checkbox" value="' +
        data.value.replace(/\s+/g, '-').toLowerCase() +
        '"class="regioncheck-' +
        data.value.replace(/\s+/g, '-').replace(/'/g, '').toLowerCase() +
        '" id="' + (type + '-' + data.value).replace(/\s+/g, '-').toLowerCase() + '"';
    
    if (data.isRefined) {
        template += ' checked';
    }
    template += '><span></span></label></div>';
    return template;
};

// template for filtering numeric lists (year)
function filterNumTemplate(data, type) {
    let template = ' <div class="form__wrapper"><label for="' +
        (type + '-' + data.label).replace(/\s+/g, '-').toLowerCase()
        + '">' + data.label + '<input type="checkbox" value="' +
        data.label.replace(/\s+/g, '-').toLowerCase() +
        '" id="' + (type + '-' + data.label).replace(/\s+/g, '-').toLowerCase() + '"';
    if (data.isRefined) {
        template += ' checked';
    }
    template += '><span></span></label></div>';
    return template;
}

function hitTemplateDrop(data) {
    let hitTemplate = '<li><a href="' + data.Link + '"><span>';

    if (data.DisplayType && data.DisplayType != 'General') {
        hitTemplate += render(data.DisplayType.toUpperCase());
    }

    hitTemplate += '</span><p>' + data.Title + '</p></a></li>';
    return hitTemplate;
}

// template for community filter hits
function hitTemplateFilter(data) {
    let hitTemplate = '<div class="js-resource_item"><div class="js-resource_item--img" style="background:url(' + data.ImageURL + ') no-repeat center center; background-size:cover;">' +
        '<a href="' + data.Link + '">';

    if (data.ImageURL) {
        hitTemplate += '<img src="' + data.ImageURL + '">';
    } else {
        // TODO: default image? or nothing?
    }

    hitTemplate += '</a></div><!---->' +
        '<div class="js-resource_item--content"><span>';
    if (data.Region && data.DisplayType == 'Success Story') {
        hitTemplate += data.Region[0];
    } else {
        hitTemplate += render(data.DisplayType);
    }

    hitTemplate += '</span><a href="' + data.Link + '"><h3>' +
        data.Title + '</h3></a>' + render(data.Summary);

    if (data.Date) {
        let options = { day: "numeric", month: "long", year: "numeric" };
        let date = new Date(data.Date * 1000).toLocaleDateString("en-NZ", options);
        hitTemplate += '<div class="js-resource_item--content__details"><p>' +
            date + '</p></div>';
    }

    hitTemplate += '<a href="' + data.Link + '" class="arrow">See more</a></div></div>';

    return hitTemplate;
}

// template for event holder hits
function hitTemplateEvent(data) {
    let month = { month: "short" };
    let dayNum = { day: "numeric" };
    let date = new Date(data.Date * 1000);
    let regions = '';

    if (data.Region && data.Region.length > 0) {
        for (let i = 0; i < data.Region.length; i++) {
            regions += data.Region[i];
            if (i < data.Region.length - 1) {
                regions += ', ';
            }
        }
    }

    let hitTemplate =
        '<div class="event__item">' +
        '<a href="' + data.Link + '">' +
        '<div class="event__item--top"' +
        'style="background: url(' + data.ImageURL + ') center center; ' +
        'background-size: cover;">' +
        '<div class="event__item--top__date">' +
        '<span>' + date.toLocaleDateString("en-NZ", month) + '</span>' +
        '' + date.toLocaleDateString("en-NZ", dayNum) + '</div>' +
        '</div>' +
        '<div class="event__item--bottom">';

    if (regions) {
        hitTemplate += '<h3>' + regions + '</h3>';
    }

    hitTemplate +=
        '<h2>' + data.Title + '</h2>' +
        '</div>' +
        '</a>' +
        '</div>';

    return hitTemplate;
}

// get path of icon to display
function getIcon(data) {
    if (validTypes.indexOf(data.DisplayType) == -1) {
        if (validTypes.indexOf(data.Class) == -1) {
            return '../_resources/ako/src/images/icon-thesis.svg';
        } else {
            return '../_resources/ako/src/images/icon-' + data.Class.replace(/\s+/g, '-').toLowerCase() + '.svg';
        }
    } else {
        return '../_resources/ako/src/images/icon-' + data.DisplayType.replace(/\s+/g, '-').toLowerCase() + '.svg';
    }
}

function renderHitTemplateDate(data) {
    let options = { day: "numeric", month: "long", year: "numeric" };
    if (data.Date) {
        if (data.Class == 'Project' && Date.now() < new Date(data.Date * 1000)) {
            return '<li> In Progress </li>';
        } else {
            let date = new Date(data.Date * 1000).toLocaleDateString("en-NZ", options);
            return `<li>${date}</li>`;
        }
    } else if (data.File && data.File.Edited){
        let date = new Date(data.File.Edited).toLocaleDateString("en-NZ", options);
        return `<li> ${date} </li>`;
    } else {
        return ''
    }
}

function renderHitTemplateList(dataList) {
    let template = '';
    if (template) {
        for (let i = 0; i < template.length; i++) {
            template += `<li>${template[i]}</li>`;
        }
    }
    return template;
}

function renderHitTemplateFile(data) {
    if (data) {
        return ` <p>(${data.Extension.toUpperCase()}, ${data.Size})</p>`
    }
    return '';
}



// WEBPACK FOOTER //
// ./src/js/search/searchWidgets.js